export const classes = {
    gridContainer: {
        justifyContent: 'space-between'
    },
    boxButton: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    boxInput: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        transition: 'ease',
        transitionDuration: 0.3,
        flexDirection: 'column'
    },
    roll: {
        transition: 'ease',
        transitionDuration: 0.5
    },
    first: {
        height: '140px',
        paddingTop: 5,
    }
};